import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';
import styles from './uploadInteraction.scss';
import a11yIIBScreenReaderService from '../../../../services/a11yIIBScreenReaderService';

const UploadButton = ({
    disabled,
    handleFileSelection,
    id,
    isFocused,
    supportedFileExtensions,
    text,
}) => {
    const inputFileRef = useRef(null);
    const acceptProp = supportedFileExtensions === '*' ? undefined : supportedFileExtensions;
    const className = disabled ? styles.uploadButtonLabelDisabled : styles.uploadButtonLabel;

    useEffect(() => {
        if (isFocused) {
            inputFileRef.current.focus();
        }
    }, []);

    const onChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            handleFileSelection(file);
        }
    };

    const isReplaceButton = text === t('interactions.upload.btnReplace');
    const ariaLabelText = isReplaceButton
        ? t('interactions.upload.a11yBtnReplace')
        : t('interactions.upload.uploadButtonAriaLabel');
    const ariaLabelValueBasedOnBtnText = a11yIIBScreenReaderService.getAriaLabelValue(
        undefined,
        ariaLabelText
    );

    const ariaLabelledByValue = a11yIIBScreenReaderService.isA11yIterationForIIBScreenReaderSupported() ? undefined : id;

    return (
        <div>
            <input
                className={styles.uploadInput}
                id={id}
                accept={acceptProp}
                ref={inputFileRef}
                disabled={disabled}
                onChange={onChange}
                type="file"
                {...(ariaLabelledByValue
                    ? { 'aria-labelledby': ariaLabelledByValue }
                    : { 'aria-label': ariaLabelValueBasedOnBtnText })}
            />

            <label htmlFor={id} className={`${styles.button} ${className}`}>
                <i className="fa fa-folder-open-o" aria-hidden="true" />
                <span>{text}</span>
            </label>
        </div>
    );
};

UploadButton.propTypes = {
    disabled: PropTypes.bool,
    handleFileSelection: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    isFocused: PropTypes.bool,
    supportedFileExtensions: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

UploadButton.defaultProps = {
    disabled: false,
    isFocused: false,
};

export default UploadButton;
